<ng-container *ngIf="true" >
  <span class="font-14"
   [ngClass]="{'badge badge-pill px-3': campoUtility.Colore(campo,item)}"
   [ngStyle]="{'color': campoUtility.Colore(campo,item)?  LightenColor(campoUtility.Colore(campo,item)) : '', 'background-color': campoUtility.Colore(campo,item)}">
    <ng-container *ngFor="let oggetto of campo.oggetti; let i = index">
      <app-field-viewer *ngIf="!CampoIs(campo, ['objArray', 'replace'])" [Campi]="[campo]" (refresh)="Refresh()"  [hideLabel]="true" [Oggetto]="item"></app-field-viewer>
      <ng-template [ngIf]="campo.type == 'replace' ">
        {{campoUtility.Replace(campo, item, oggetto)}} &nbsp;
      </ng-template>
      <ng-template [ngIf]="campo.type == 'objArray' ">
        <ng-container *ngFor="let obg of campoUtility.getObj(item, oggetto)">
          {{obg[campo.field[i]]}}&nbsp;
        </ng-container>
      </ng-template>
   </ng-container>
  </span>
</ng-container>
